import { render, staticRenderFns } from "./DetailVMHistory.vue?vue&type=template&id=2ea65f4b&scoped=true"
import script from "./DetailVMHistory.vue?vue&type=script&lang=js"
export * from "./DetailVMHistory.vue?vue&type=script&lang=js"
import style0 from "./DetailVMHistory.vue?vue&type=style&index=0&id=2ea65f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea65f4b",
  null
  
)

export default component.exports